// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AIUJ","title":"styles_title__2zxcp"};